import type { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';
import classes from './Setup.module.css';
import type { TemporaryPasswordDrop } from './setup-types.js';

/**
 * Yönetici hesabına geçişte geçici parolası iptal edilen kişinin bildirimi (ADR 0150 §6 sınır c).
 * Kişi şirket rolü, gemi ataması, Sign On / Off ya da matris sürümüyle yönetici hesabı olunca
 * bekleyen geçici parolası düşer ve giremez; işlemi yapan yönetici nedenini ve ne yapacağını
 * görür: "Reset password" ile yeni geçici parola. Eski sunucu alanı göndermez: bildirim yok.
 */

/** Kişilerin adıyla metin (Settings ▸ Users, Sign On / Off, personel kartı); düşen yoksa `null`. */
export function temporaryPasswordDroppedText(
  t: TFunction,
  dropped: readonly TemporaryPasswordDrop[] | undefined,
): string | null {
  if (!dropped || dropped.length === 0) return null;
  return t('setup.users.temporaryPasswordDropped', {
    count: dropped.length,
    names: dropped.map((person) => person.fullName).join(', '),
    action: t('setup.users.action.resetPassword'),
  });
}

/** Matris kaydı: rolü yönetici rolü olan kişilerin sayısı; düşen yoksa `null`. */
export function matrixTemporaryPasswordDroppedText(
  t: TFunction,
  dropped: readonly TemporaryPasswordDrop[] | undefined,
): string | null {
  if (!dropped || dropped.length === 0) return null;
  return t('setup.matrix.save.temporaryPasswordDropped', {
    count: dropped.length,
    action: t('setup.users.action.resetPassword'),
  });
}

/** Uyarı tonunda bildirim; `count` matris kaydında yalnız sayıyı söyler. */
export function TemporaryPasswordDroppedNotice({
  dropped,
  count = false,
  className,
}: {
  dropped: readonly TemporaryPasswordDrop[] | undefined;
  count?: boolean;
  /** Yerleşime göre boşluk (ör. çekmecede kaydedilen bölümün altı). */
  className?: string | undefined;
}) {
  const { t } = useTranslation();
  const text = count
    ? matrixTemporaryPasswordDroppedText(t, dropped)
    : temporaryPasswordDroppedText(t, dropped);
  if (text === null) return null;
  return (
    <p
      className={className ? `${classes.notice} ${className}` : classes.notice}
      data-tone="warning"
      role="status"
    >
      {text}
    </p>
  );
}
